import React from "react"
import {
  ColumnsContainer,
  Container,
  RowsContainer,
} from "component_library/components/react/FlexDiv"
import HeaderItems, {
  type HeaderItemsProps,
} from "component_library/components/react/HeaderItems"
import Content from "./Content"

export interface HeaderProps extends HeaderItemsProps {
  alert?: React.ReactNode
  leftContent: React.ReactNode
  rightContent: React.ReactNode
}

/**
 * Header for the Pro Valuation Tool
 */
const Header = ({
  alert,
  baseName,
  customerName,
  leftContent,
  productName,
  rightContent,
  headerMenuItems,
  customersWithDepartments,
  authenticityToken,
  user,
  texts,
}: HeaderProps): JSX.Element => {
  return (
    <RowsContainer gap={6}>
      <Container flex={1} justify="center">
        <HeaderItems
          texts={texts}
          productName={productName}
          customerName={customerName}
          baseName={baseName}
          headerMenuItems={headerMenuItems}
          customersWithDepartments={customersWithDepartments}
          authenticityToken={authenticityToken}
          user={user}
        />
      </Container>

      {alert && <Content align="stretch">{alert}</Content>}

      {(leftContent || rightContent) && (
        <ColumnsContainer align="center" gap={2} paddingX={5}>
          {leftContent && (
            <Container flex={1} justify="start">
              {leftContent}
            </Container>
          )}
          {rightContent && !leftContent && (
            <Container flex={1} justify="start"></Container>
          )}
          {rightContent && (
            <Container flex={1} justify="end">
              {rightContent}
            </Container>
          )}
          {!rightContent && leftContent && (
            <Container flex={1} justify="end"></Container>
          )}
        </ColumnsContainer>
      )}
    </RowsContainer>
  )
}

/** We export a higher order component to utilize the `theme` prop */
export default Header
